module.exports = __webpack_public_path__ + "img/contact.f584b04d.png";